export abstract class Analytics {
    public static readonly AnalyticsByKioskQuery: string = "AnalyticsByKioskQuery";
    public static readonly AnalyticsByGroupQuery: string = "AnalyticsByGroupQuery";
    public static readonly AnalyticsByCustomerQuery: string = "AnalyticsByCustomerQuery";
    public static readonly StatisticsQuery: string = "StatisticsQuery";    
}